export const DATA_SAVE_IN_REDUX = "DATA_SAVE_IN_REDUX";
export const DataSaveInRedux = (data) => ({
  type: DATA_SAVE_IN_REDUX,
  payload: data,
});
